/**
 * Hidden agent-only note attached to a user message.
 *
 * Sometimes we need to hand Maya an instruction alongside what the merchant
 * typed (e.g. "they skipped the setup card — just generate") WITHOUT showing that
 * instruction in the chat bubble. The note rides inside the message content
 * wrapped in sentinel markers: the agent reads the whole string (markers are just
 * text to the LLM), while the UI strips the marked span before rendering the
 * user's bubble.
 */
const OPEN = '[[agent-note]]';
const CLOSE = '[[/agent-note]]';

/** Append an agent-only note to the visible text (agent sees it, UI hides it). */
export function withHiddenAgentNote(visible: string, note: string): string {
  return `${visible}\n\n${OPEN}${note}${CLOSE}`;
}

/** Remove any agent-only note span so it never renders in the user's bubble. */
export function stripHiddenAgentNote(text: string): string {
  if (!text.includes(OPEN)) return text;
  return text
    .replace(/\s*\[\[agent-note\]\][\s\S]*?\[\[\/agent-note\]\]\s*/g, '')
    .trimEnd();
}
